import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full flex flex-wrap" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "ml-3" }, " Ao continuar, você concorda com nossa política de Cookies e termos de tratamento de dados de acordo com a nossa política de privacidade. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "w-full" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "ml-3",
    href: "https://moinhoglobo.com.br/politica-de-privacidade/",
    style: {"text-decoration":"underline","color":"blue"},
    target: "_blank"
  }, "https://moinhoglobo.com.br/politica-de-privacidade/")
], -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

import { ref, computed } from "vue";
import DialogModal from "../Modal/DialogModal.vue";
import ListHeader from "../ListHeader.vue";
import FormValidated from "../FormValidated.vue";
import InputText from "../inputs/InputText.vue";
import helpers from "@/helpers";
import axios from "axios";
import store from "@/store";

interface IForm {
  cnpj: string;
  email: string;
  celular: string;
  observacoes: string;
  razao_social: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SolicitarAcesso',
  props: {
  show: {
    type: Boolean,
    default: false,
  },
},
  emits: ["close"],
  setup(__props, { emit }) {

const props = __props;



const newForm = () => {
  return {
    cnpj: "",
    email: "",
    celular: "",
    observacoes: "",
    razao_social: "",
  } as IForm;
};

const initialValues = ref(newForm());



const validation = {
  cnpj: "required|min:14",
  razao_social: "required",
  email: "required|min:5",
  celular: "required|min:10",
};

const isLoading = computed(() => store.state.isLoadingSolicitaAcesso);

const onSubmit = async (values: IForm) => {
  await store.dispatch("solicitaAcesso", values);

  helpers.mensagemSucesso(
    "Solicitação enviada com sucesso! Fique atento ao seu email/celular."
  );
  initialValues.value = newForm();
  emit("close", true);
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_t_button = _resolveComponent("t-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(DialogModal, { show: __props.show }, {
      title: _withCtx(() => [
        _createVNode(ListHeader, { label: "Solicitar acesso" })
      ]),
      content: _withCtx(() => [
        _createVNode(FormValidated, {
          "initial-values": initialValues.value,
          "hide-buttons": true,
          onSave: onSubmit,
          validation: validation
        }, {
          form: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(InputText, {
                name: "razao_social",
                tclass: "md:w-full",
                label: "Razão Social"
              }),
              _createVNode(InputText, {
                name: "cnpj",
                mascara: "99.999.999/9999-99",
                tclass: "md:w-1/2",
                label: "CNPJ/CPF"
              }),
              _createVNode(InputText, {
                name: "celular",
                tclass: "md:w-1/2",
                mascara: "(99) 99999-9999",
                label: "Celular"
              }),
              _createVNode(InputText, {
                name: "email",
                tclass: "w-full",
                label: "E-mail"
              }),
              _createVNode(InputText, {
                name: "observacoes",
                tclass: "w-full",
                label: "Observações",
                type: "textarea",
                rows: 5
              }),
              _hoisted_2,
              _hoisted_3,
              _hoisted_4,
              _createVNode(_component_t_button, {
                class: "ml-3",
                type: "submit"
              }, {
                default: _withCtx(() => [
                  (_unref(isLoading))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "sync-alt",
                          spin: ""
                        }),
                        _createTextVNode(" Enviando...")
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, "Solicitar acesso"))
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["initial-values"])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_t_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close', true))),
          color: "gray"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Fechar")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})